import { Divider, Grid, Stack, Typography } from "@mui/material";
import { useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DEFAULT_TURNOFF_AUTOPAY_DISCOUNT } from "../../../Constants/constants";
import { editAutoPayEnable } from "../../../Redux/Slices/EditAutoPaySlice";
import { convertToPositive, getBannerMessageByKey } from "../../../Services/helper";
import { Android12Switch, ColumnCenterStack, RowCenterStack } from "../../../Styles/GlobalStyles";
import { Theme } from "../../../Styles/GlobalTheme";
import Button from "../../Button/Button";

export const CustomManage = ({
  handleConfirm,
  setDialogOpen,
  setUnread,
  unread,
  manageData,
  dialogData,
  setDialogData,
}: any) => {
  const dispatch = useDispatch();
  const { isSaveAutoPayChanges } = useSelector((state: any) => state.editAutoPay);
  const { accountNumber } = useSelector((state: any) => state.customerInfoDetails);
  const { autopayAmount, autopaySurchargeDetails, isSMB, showAutopayDiscountMessage } = useSelector(
    (state: any) => state.customerPlanDetails
  );
  const sideCoreBannerMessages = useSelector(
    (state: any) => state?.sideCoreContent?.bannerMessages
  );
  const turnoffAutopayDiscount = getBannerMessageByKey(
    "turnoff-autopay-discount",
    sideCoreBannerMessages
  );
  const handleChange = () => {
    setUnread(true);
    setDialogOpen(true);
    setDialogData({
      ...dialogData,
      heading:
        turnoffAutopayDiscount?.content?.heading[0]?.text ||
        DEFAULT_TURNOFF_AUTOPAY_DISCOUNT.content.heading[0].text,
      primaryContent:
        turnoffAutopayDiscount?.content?.subheading[0]?.text ||
        DEFAULT_TURNOFF_AUTOPAY_DISCOUNT.content.subheading[0].text,
      secondaryContent:
        turnoffAutopayDiscount?.content?.subheading[1]?.text ||
        DEFAULT_TURNOFF_AUTOPAY_DISCOUNT.content.subheading[1].text,
      containedButton: {
        ...dialogData?.containedButton,
        buttonType: "root",
        buttonTitle:
          turnoffAutopayDiscount?.content?.subheading[2]?.text ||
          DEFAULT_TURNOFF_AUTOPAY_DISCOUNT.content.subheading[2].text,
        eventName: "TURN_OFF_AUTOPAY",
      },
    });
  };
  const handleEditAutoPay = () => {
    dispatch(editAutoPayEnable(true));
  };
  const hyphenSeperatedAccNum = accountNumber?.replace(
    /^(\d{3})(\d{3})(\d{4})(\d{6})(\d)$/,
    "$1-$2-$3-$4-$5"
  );

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <ColumnCenterStack direction={"row"}>
        {isSaveAutoPayChanges ? (
          <Typography fontSize={{ xs: "16px", sm: "18px" }} fontWeight={600}>
            Review and confirm autopay settings
          </Typography>
        ) : (
          <RowCenterStack width={"100%"}>
            <Typography variant="subtitle1" fontWeight={600}>
              Autopay
            </Typography>
            <Stack direction={"row"} spacing={2} alignItems={"center"}>
              <Typography
                display={{ xs: "none", sm: "block" }}
                fontSize={"12px"}
                color={Theme.palette.customcolor.emailTextColor}>
                {unread ? "TURNED ON" : "TURNED OFF"}
              </Typography>
              <Android12Switch
                color="secondary"
                disableRipple
                inputProps={{ "aria-label": "ant design" }}
                onChange={handleChange}
                checked={unread}
              />
            </Stack>
          </RowCenterStack>
        )}
      </ColumnCenterStack>
      <Grid container justifyContent={"space-between"} spacing={2} my={1}>
        <Grid item xs={12} md={5.6}>
          <Stack gap={2}>
            <Stack>
              <Typography fontSize={"0.8rem"} component={"p"}>
                Account number
              </Typography>
              <Typography variant="subtitle2" component={"span"} mb={1} data-testid="accountNumber">
                {hyphenSeperatedAccNum}
              </Typography>
              <Divider />
            </Stack>
            <Stack>
              <Typography fontSize={"0.8rem"} component={"p"}>
                Payment method
              </Typography>
              <Typography variant="subtitle2" component={"p"} mb={1} data-testid="name-on-card">
                {manageData?.paymentMethodName
                  ? manageData?.paymentMethodName
                  : manageData?.nameOnTheCard}
              </Typography>
              <Divider />
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={12} md={5.5}>
          <Stack gap={2}>
            <Stack>
              <Typography fontSize={"0.8rem"} component={"p"}>
                Payment to be applied
              </Typography>
              {manageData?.scheduleDayBefore && (
                <Typography variant="subtitle2" component={"p"} mb={1} data-testid="schedule-day">
                  {convertToPositive(manageData?.scheduleDayBefore ?? "")} day(s) before your due
                  date
                </Typography>
              )}
              <Divider />
            </Stack>
            <Stack>
              <Typography fontSize={"0.8rem"} component={"span"}>
                Amount
              </Typography>
              <Typography variant="subtitle2" component={"span"} mb={1} data-testid="amount-type">
                Total amount due for billing cycle
              </Typography>
              <Divider />
            </Stack>
          </Stack>
        </Grid>
        {isSaveAutoPayChanges ? (
          <Stack sx={{ mt: 4, mx: 2 }}>
            <Button
              onClick={handleConfirm}
              eventName="MANAGE_AUTOPAY_CONFIRM"
              type="payment"
              title="confirm"
            />
          </Stack>
        ) : (
          <Stack sx={{ mt: 4, mx: 2 }}>
            <Button
              title="Edit"
              eventName="MANAGE_AUTOPAY_EDIT"
              onClick={handleEditAutoPay}
              type="payment"
            />
          </Stack>
        )}
      </Grid>
    </>
  );
};
